import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import { MemberListDTO, MemberDTO } from '../dto/MemberManagementDTOs';
import { genNoobookHeader } from './Common';

/**
 * 회원 목록 조회
 * @param authToken 인증 토큰
 * @param startDate 시작일 (YYYY-MM-DD, 선택)
 * @param endDate 종료일 (YYYY-MM-DD, 선택)
 * @param ageGroup 연령대별 필터 (선택)
 * @param searchKeyword 검색 키워드 (아이디/닉네임, 선택)
 * @param status 상태 필터 (선택)
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getMemberList(
  authToken: string,
  startDate?: string,
  endDate?: string,
  ageGroup?: string,
  searchKeyword?: string,
  status?: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<MemberListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (ageGroup) params.ageGroup = ageGroup;
  if (searchKeyword) params.searchKeyword = searchKeyword;
  if (status) params.status = status;

  return ApiComm.getData<ResponseDTO<MemberListDTO>>(
    '/admin/v1/members',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환 (서버 API 준비 전까지 사용)
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockMembers: MemberDTO[] = [
        {
          memberNo: 1,
          nickname: '독서광',
          userId: 'user123',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 15,
          scriptingCount: 3,
          status: 'NORMAL',
        },
        {
          memberNo: 2,
          nickname: '독서광',
          userId: 'user124',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 10,
          scriptingCount: 3,
          status: 'NORMAL',
        },
        {
          memberNo: 3,
          nickname: '독서광',
          userId: 'user125',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 10,
          scriptingCount: 3,
          status: 'NORMAL',
        },
        {
          memberNo: 4,
          nickname: '독서광',
          userId: 'user125',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 57,
          scriptingCount: 4,
          status: 'SUSPENDED',
        },
        {
          memberNo: 5,
          nickname: '독서광',
          userId: 'user127',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 10,
          scriptingCount: 3,
          status: 'NORMAL',
        },
        {
          memberNo: 6,
          nickname: '독서광',
          userId: 'user128',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 10,
          scriptingCount: 3,
          status: 'NORMAL',
        },
        {
          memberNo: 7,
          nickname: '독서명',
          userId: 'user129',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 10,
          scriptingCount: 3,
          status: 'NORMAL',
        },
        {
          memberNo: 8,
          nickname: '독서장',
          userId: 'user1210',
          joinDate: '2023-01-15',
          lastAccessDate: '2023-10-27',
          readingCount: 2,
          scriptingCount: 3,
          status: 'SUSPENDED',
        },
      ];

      const mockData: MemberListDTO = {
        members: mockMembers,
        page: {
          current: page,
          last: 3,
          total: 25,
        },
      };

      const response: ResponseDTO<MemberListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300); // API 호출 시뮬레이션을 위한 약간의 지연
  });
}
